import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { cn } from '../../../lib/utils.js';

const TitleList = ({ type, title, desc, className }) => {
  return /* @__PURE__ */ jsx(Fragment, { children: title ? /* @__PURE__ */ jsxs(
    "dl",
    {
      className: cn(
        "flex flex-col [&+&]:mt-6",
        type === "inverse" && "gap-1 md:gap-2",
        className
      ),
      children: [
        /* @__PURE__ */ jsx(
          "dt",
          {
            className: cn(
              "body-lg text-basic-02 font-weight-medium mb-2",
              type === "small" && "mb-2",
              type === "inverse" && "body-md font-weight-medium text-basic-04 mb-0"
            ),
            children: title
          }
        ),
        /* @__PURE__ */ jsx(
          "dd",
          {
            className: cn(
              "body-lg text-basic-04 break-words",
              type === "small" && "body-md",
              type === "inverse" && "!heading-h5 font-weight-medium text-basic-02"
            ),
            children: desc
          }
        )
      ]
    }
  ) : /* @__PURE__ */ jsx(
    "div",
    {
      className: cn(
        "body-lg text-basic-04 break-words",
        type === "small" && "body-md",
        type === "inverse" && "!heading-h5 font-weight-medium text-basic-02"
      ),
      children: desc
    }
  ) });
};

export { TitleList };
